module.exports = __webpack_public_path__ + "static/img/black-coby.8f69921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/black-coby.jpg
// module id = BZAG
// module chunks = 0